import { typography } from '@/shared/theme/tokens';
import { TERM } from '../liveModeMeta';
import { Pane, PaneHeader } from './Pane';
import { AlertTickerItem } from './AlertTickerItem';

const MONO = typography.fontFamily.mono;

/**
 * Alert log. Alerts arrive pre-ranked from the screen (severity → actionability →
 * recency, stale sunk); each row's colour tracks its value's current standing.
 */
export function AlertRail({ alerts = [], flashId, animate, onSelect }) {
  const sorted = alerts;

  return (
    <Pane>
      <PaneHeader title="Live Alerts" count={sorted.length} accent={TERM.crit} />
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {sorted.length === 0 ? (
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, padding: 24 }}>
            <span className="material-symbols-outlined" style={{ fontSize: 28, color: TERM.ok }}>check_circle</span>
            <span style={{ fontFamily: MONO, fontSize: typography.fontSize.md, fontWeight: typography.fontWeight.bold, letterSpacing: typography.letterSpacing.wide, color: TERM.ink }}>
              ALL PARAMETERS IN RANGE
            </span>
          </div>
        ) : (
          sorted.map((a) => (
            <AlertTickerItem key={a.id} alert={a} flashing={a.id === flashId} animate={animate} onSelect={onSelect} />
          ))
        )}
      </div>
    </Pane>
  );
}
